module.exports = __webpack_public_path__ + "img/about.796c52ac.jpg";